import collateralAsset from "@/api/credit-operation/collateral-asset";

import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        );
        return collateralAsset.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return collateralAsset.store(data);
    },
    update(context, { id, data }) {
        return collateralAsset.update(id, data);
    },
    destroy(context, id) {
        return collateralAsset.destroy(id);
    },
    changeIsActive(context, { id, data }) {
        return collateralAsset.changeIsActive(id, data);
    }
};
